﻿$(function () {
    $.Mediator = {
        init: function () {
        },
        initDeliveryPage: function () {
            initDeliveryMap();
        },
        initCartPage: function (ids) {
            // window.shop.initOrderDelivery();
            if (ids) {
                // $.Cart.initRelatedSlider(ids);
            }
            window.shop.initCartCheckout();
        }
    };

    $.Mediator.init();
});